import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';

// Bounces to /login if no session. Preserves the intended destination via
// `?return_to=...` so the OAuth callback can land the user back where they
// started.
export default function ProtectedRoute() {
  const { user, isLoading, isAuthed } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div className="loading">Loading…</div>;
  }
  if (!isAuthed) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?return_to=${returnTo}`} replace />;
  }
  return <Outlet context={{ user }} />;
}
